import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation,
  useServices
} from 'cng-web-lib'

import AceOcnPermitToTransferApiUrls from 'src/apiUrls/AceOcnPermitToTransferApiUrls'
import React,{useRef, useState,useEffect} from 'react'
import AceOcnPermitToTransferKeys from 'src/constants/locale/key/AceOcnPermitToTransfer'
import Namespace from 'src/constants/locale/Namespace'
import UserProfileApiUrls from "src/apiUrls/UserProfileApiUrls";
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Table from 'src/components/aciacehighway/Table'
import { FileForUserGetPartyId, GetFilterByUserIdCriteria } from 'src/common/FileForUserCommon'
import TemplateSelectDialogWithOptionACEOceanPermitToTransfer from './manifest/TemplateSelectDialogWithOptionACEOceanPermitToTransfer'
import moment from 'moment-timezone'
import { getStatusMetadata } from 'src/common/NACommon'
import { Typography } from '@material-ui/core'
import pathMap from 'src/paths/pathMap'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    DateRangeFilter: CngDateRangeFilter,
    useDefaultNotification
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

const { filter: { IN,LIKE, BETWEEN ,EQUAL} } = constants

function TablePage(props) {
  const { history, location, showNotification } = props
  const { securedSendRequest, deleteRecord } = useServices()

  const tableRef = useRef(null)
    const [manifestTemplateDialog, setManifestTemplateDialog] = useState(false)
  
  const [confirmDelete, setConfirmDelete] = useState({ open: false, aceOcnPTTManifestHeaderDTO: null })
  const [sbPartyIdList, setSBPartyIdList] = useState([])
  const [sbPartyIdFetched, setSBPartyIdFetched] = useState(false)

  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.ACE_OCN_PERMIT_TO_TRANSFER
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let aceOcnPTTManifestHeaderDTO = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: aceOcnPTTManifestHeaderDTO
      }
    )
    let scac = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.SCAC
    )
    let vesselName = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.VESSEL_NAME
    )
    let voyageNumber = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.VOYAGE_NUMBER
    )
    let country = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.COUNTRY
    )
    let portOfDischarge = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.PORT_OF_DISCHARGE
    )
    let eta = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.ETA
    )
    let modeOfTransport = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.MODE_OF_TRANSPORT
    )
    let paperlessInBondParticipant = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.PAPERLESS_IN_BOND_PARTICIPANT
    )
    let issuerScac = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.ISSUER_SCAC
    )
    let createdDate = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.CREATED_DATE
    )
    let responseDate = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.RESPONSE_DATE
    )
    let status = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.STATUS
    )
    let submittedDate = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.SUBMITTED_DATE
    )

    return {
      aceOcnPTTManifestHeaderDTO,
      tableTitle,
      scac,
      vesselName,
      voyageNumber,
      country,
      portOfDischarge,
      eta,
      modeOfTransport,
      paperlessInBondParticipant,
      issuerScac,
      status,
      submittedDate,
      createdDate,
      responseDate
    }
  }

  const columns = [
    {
      field: "id",
      sortKey: "id",
      title: "ID",
    },
    {
      field: "scac",
      sortKey: "scac",
      title: translatedTextsObject.scac,
    },
    {
      field: "vesselName",
      sortKey: "vesselName",
      title: translatedTextsObject.vesselName,
    },
    {
      field: "voyageNumber",
      sortKey: "voyageNumber",
      title: translatedTextsObject.voyageNumber,
    },
    {
      field: "country",
      sortKey: "country",
      title: translatedTextsObject.country,
    },
    {
      field: "portOfDischarge",
      sortKey: "portOfDischarge",
      title: translatedTextsObject.portOfDischarge,
    },
    {
      field: "eta",
      sortKey: "eta",
      title: translatedTextsObject.eta,
      type: "date",
      filterComponent: CngDateRangeFilter,
    },
    {
      field: "submittedDate",
      sortKey: "submittedDate",
      title: translatedTextsObject.submittedDate,
      type: "date",
      filterComponent: CngDateRangeFilter,
      render: (data) => data.submittedDate && moment(data.submittedDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: "status",
      sortKey: "status",
      title: translatedTextsObject.status,
      render: (rowData) => {
        const { color, label } = getStatusMetadata(rowData.status)
        return <Typography style={{ color }}>{label}</Typography>
      }
    },
    {
      field: "responseDate",
      sortKey: "responseDate",
      title: translatedTextsObject.responseDate,
      type: "date",
      filterComponent: CngDateRangeFilter,
      render: (data) => data.responseDate && moment(data.responseDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: "createdDate",
      sortKey: "createdDate",
      title: translatedTextsObject.createdDate,
      type: "date",
      filterComponent: CngDateRangeFilter,
      render: (data) => data.createdDate && moment(data.createdDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    }
  ]

  const filters = [
    {
      label: "ID",
      type: 'textfield',
      name: 'id',
      operatorType: EQUAL
    },
    {
      type: 'textfield',
      name: 'scac',
      operatorType: LIKE
    },
    {
      type: 'textfield',
      name: "vesselName",
      operatorType: LIKE
    },
    {
      type: 'textfield',
      name: "voyageNumber",
      operatorType: LIKE
    },
    {
      type: 'textfield',
      name: "country",
      operatorType: LIKE
    },
    {
      type: 'textfield',
      name: "portOfDischarge",
      operatorType: LIKE
    },
    {
      name: "eta",
      type: "daterange",
      operatorType: BETWEEN,
    },
    {
      label: translatedTextsObject.submittedDate,
      type: 'daterange',
      name: 'submittedDate',
      operatorType: BETWEEN
    },
    {
      label: translatedTextsObject.status,
      type: 'checkbox',
      name: 'status',
      operatorType: IN,
      options: [
        {
          fullWidth: true,
          label: 'Draft',
          value: '1005',
          filterValue: { value: '1005' }
        },
        {
          fullWidth: true,
          label: 'Accepted',
          value: '1000',
          filterValue: { value: '1000' }
        },
        {
          fullWidth: true,
          label: 'Sent',
          value: '1008',
          filterValue: { value: '1008' }
        },
        {
          fullWidth: true,
          label: 'Rejected',
          value: '1001',
          filterValue: { value: '1001' }
        },
        {
          fullWidth: true,
          label: 'Cancel',
          value: '1011',
          filterValue: { value: '1011' }
        },
        {
          fullWidth: true,
          label: 'Status Notification',
          value: '1006',
          filterValue: { value: '1006' }
        }
      ]
    },
    {
      label: translatedTextsObject.responseDate,
      type: 'daterange',
      name: 'responseDate',
      operatorType: BETWEEN
    },
    {
      label: translatedTextsObject.createdDate,
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    }
  ]

  function handleDeletePTT() {
    if (!confirmDelete.aceOcnPTTManifestHeaderDTO) return

    setConfirmDelete({ open: false })

    deleteRecord.execute(AceOcnPermitToTransferApiUrls.DELETE, confirmDelete.aceOcnPTTManifestHeaderDTO,
      () => {
        showNotification('success', 'Delete succeeded')
        setConfirmDelete({ open: false, aceOcnPTTManifestHeaderDTO: null })
        tableRef.current.performRefresh()
      },
      (error) => { console.log(error) }
    )
  }

  function DisableEditButton(rowData) {
    return rowData.status == '1008'
  }

  function DisableDeleteButton(rowData) {
    return rowData.status != '1005' && rowData.status != '1002'
  }

  useEffect(() => {
    let loginId = "";
    let userPreference = localStorage.getItem("userPreference");
    let fileForUserDetails = sessionStorage.getItem("fileForUserDetails");
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      setSBPartyIdList([])
      setSBPartyIdFetched(true);
    } else {
      let userPreferenceJSON = JSON.parse(userPreference);
      loginId = userPreferenceJSON.tprUserDetail.userProfile.loginId;
    }
    console.log("loginId: " + JSON.stringify(loginId));

    if (loginId !== "") {
      function onSuccess(response) {
        setSBPartyIdList(response.data)
        setSBPartyIdFetched(true);
        console.log("sbPartyIdList: " + JSON.stringify(sbPartyIdList));
      }

      function onError(error) {
        console.log("sbPartyIdList Error: " + JSON.stringify(error));
      }

      function onComplete() { }
      const config = {}

      securedSendRequest.execute('POST', UserProfileApiUrls.SB_PARTYID_LIST, { loginId }, onSuccess, onError, onComplete, config, null);

    }
  }, [])

  let filter = GetFilterByUserIdCriteria("ACEOCN")

  return (
    <>
      {sbPartyIdFetched && ( <Table
        actions={[
          {
            label: 'Create Permit To Transfer from Manifest',
            buttonProps: {
              color: 'primary', size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => setManifestTemplateDialog(true)
            }
          },
          {
            label: 'Create New PTT',
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(`${pathMap.ACE_OCN_PERMIT_TO_TRANSFER_ADD_VIEW}`)
            }
          }
        ]}
        columns={columns}
        compact
        exportData={{ url: AceOcnPermitToTransferApiUrls.EXPORT }}
        fetch={{ url: AceOcnPermitToTransferApiUrls.GET }}
        fetchFilters={[
          { field: 'partyId', operator: IN, value: sbPartyIdList.length > 0 ? sbPartyIdList : FileForUserGetPartyId() },
          ...filter
        ]}
        filters={filters}
        onRowClick={(rowData) => {
          if (DisableEditButton(rowData)) {
            history.push(`${location.pathname}/view/${rowData.id}`)
          } else {
            history.push(`${location.pathname}/edit/${rowData.id}`)
          }
        }}
        rowActions={[
          {
            label: "Edit",
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            disabled: (rowData) => DisableEditButton(rowData),
            onClick: (rowData) => history.push(`${location.pathname}/edit/${rowData.id}`),
            tooltip: (rowData) => DisableEditButton(rowData) ? 'Sent records cannot be Edited' : null
          },
          {
            label: "Delete",
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            disabled: (rowData) => DisableDeleteButton(rowData),
            onClick: (rowData) => setConfirmDelete({ open: true, aceOcnPTTManifestHeaderDTO: rowData }),
            tooltip: (rowData) => DisableDeleteButton(rowData) ? 'Only Draft records can be deleted' : null
          },
        ]}
        showNotification={showNotification}
        sortConfig={{ type: 'column', defaultField: 'createdDate', defaultDirection: 'DESC' }}
        persistSettings
        tableRef={tableRef}
        //tablePreference={{ module: 'ACEOCN', key: 'bol_table_visible_column' }}
      />)}
      <TemplateSelectDialogWithOptionACEOceanPermitToTransfer
        manifestTemplateDialog={manifestTemplateDialog}
        handleClose={() => setManifestTemplateDialog(false)}
        title={"Create Permit To Transfer from Manifest"}
      />
      <ConfirmDialog
        isConfirmDialogOpen={confirmDelete.open}
        closeDialog={() => setConfirmDelete({ open: false, aceOcnPTTManifestHeaderDTO: null })}
        confirmDialog={handleDeletePTT}
        content="Items that you delete can't be restored. Are you sure about this?"
        okMsg='Yes, delete'
        cancelMsg='No, take me back'
        title={"Delete"}
      />
    </>
  )
}

export default TablePage
